import actionTypes from '../constants/action-types';

const readOnly = (state = false, action) => {
  if (action.type === actionTypes.ENABLE) {
    return true;
  }

  if (action.type === actionTypes.DISABLE) {
    return false;
  }

  return state;
};

export default readOnly;
